import { action } from 'satcheljs';
import * as React from 'react';

export default action(
    'SET_OPTIONS_SEARCH_TERM',
    (event: React.ChangeEvent<HTMLInputElement>, query: string) => ({ query })
);
